export const enumToArrayString = (theEnum: any): string[] => {
  return Object.values(theEnum)
    .map((value: any) => (typeof value === "string" ? value : null))
    .filter((n): n is string => n !== null);
};
